<template>
    <div class="signup-method">
        <h4 class="text-center mb-2" style="color: #333333;">Create Account</h4>
        <p class="text-center mb-4" style="font-size: 14px; color: #6c757d;">
            Choose how you want to sign up
        </p>

        <div class="signup-method__options">
            <!-- Opsi 1: Email + OTP -->
            <button type="button" class="method-button method-button--email" @click="$emit('select-email')">
                <i class="fas fa-envelope method-icon"></i>
                <span>Sign up with Email (OTP)</span>
            </button>

            <!-- Opsi 2: Google. Native memakai komponen yang sama seperti halaman login, web memakai OAuth redirect -->
            <GoogleLoginButton
                v-if="isNativePlatform"
                class="signup-method__option"
                button-text="Sign up with Google"
                :ref-param="refParam"
                :merchant-id="merchantId"
                @login-success="$emit('google-success', $event)"
                @login-error="$emit('google-error', $event)"
            />
            <button v-else type="button" class="google-login-button" @click="$emit('select-google')">
                <img
                    src="https://s3.ap-southeast-1.amazonaws.com/cdn-member.omnihotelier.com/images/Google__G__logo.svg.png"
                    class="google-icon"
                    alt="Google"
                >
                <span class="google-login-text">Sign up with Google</span>
            </button>

            <!-- Opsi 3: Apple. Hanya muncul di iOS. User baru: ref kosong -> form, ref terisi -> data default -->
            <template v-if="isIosPlatform">                
                <AppleLoginButton
                    class="signup-method__option"
                    button-text="Sign up with Apple"
                    :ref-param="refParam"
                    :merchant-id="merchantId"
                    @login-success="$emit('apple-success', $event)"
                    @login-error="$emit('apple-error', $event)"
                />
            </template>
        </div>

        <div class="mt-4">
            <slot name="footer"></slot>
        </div>
    </div>
</template>

<script>
import { computed } from 'vue';
import { Capacitor } from '@capacitor/core';
import GoogleLoginButton from '@/components/GoogleLoginButton.vue';
import AppleLoginButton from '@/components/AppleLoginButton.vue';

export default {
    name: 'SignUpMethodChooser',
    components: { GoogleLoginButton, AppleLoginButton },
    props: {
        // Parameter `ref` dari URL (base64 url redirect integrasi eksternal)
        refParam: { type: String, default: '' },
        // Merchant id dari URL; bersama ref = user baru langsung dibuat (tanpa form)
        merchantId: { type: String, default: '' },
    },
    emits: ['select-email', 'select-google', 'google-success', 'google-error', 'apple-success', 'apple-error'],
    setup() {
        const isNativePlatform = computed(() => Capacitor.isNativePlatform());
        const isIosPlatform = computed(() => Capacitor.getPlatform() === 'ios');
        return { isNativePlatform, isIosPlatform };
    },
};
</script>

<style scoped>
.signup-method__options {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 12px;
    width: 100%;
}

.signup-method__option {
    box-sizing: border-box;
    width: min(300px, 100%);
    max-width: 100%;
    margin-top: 0;
}

.signup-method__option :deep(.google-login-btn) {
    box-sizing: border-box;
}

/* Tombol Google: sama persis dengan .google-login-button di MemberLogin.vue */
.google-login-button {
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    background-color: white;
    color: #5f6368;
    font-size: 15px;
    font-weight: 500;
    border: 1px solid #5f6368;
    border-radius: 4px;
    padding: 10px 20px;
    cursor: pointer;
    box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1);
    width: min(300px, 100%);
    max-width: 100%;
    transition: box-shadow 0.3s ease;
}
.google-login-button:hover {
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}
.google-icon {
    margin-right: 10px;
    height: 18px;
    width: 18px;
}
.google-login-text {
    font-size: 14px;
}

/* Tombol Email: ukuran & bentuk disamakan dengan tombol Google */
.method-button {
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    width: min(300px, 100%);
    max-width: 100%;
    padding: 10px 20px;
    border-radius: 4px;
    border: 1px solid #DE5B53;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: background-color 0.3s ease, box-shadow 0.3s ease;
}
.method-button--email {
    background-color: #DE5B53;
    color: #ffffff;
}
.method-button--email:hover {
    background-color: #c44e47;
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.2);
}
.method-icon {
    margin-right: 10px;
    font-size: 15px;
}

.divider-with-text {
    display: flex;
    align-items: center;
    text-align: center;
}
.divider-with-text::before,
.divider-with-text::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid #ccc;
    margin: 0 10px;
}
.divider-with-text span {
    font-size: 14px;
    color: #666;
}
</style>